<section
  class="flex items-center h-full p-16 dark:bg-gray-50 dark:text-gray-800"
>
  <div
    class="container flex flex-col items-center justify-center px-5 mx-auto my-8"
  >
    <div class="max-w-md text-center">
      <p class="mb-8 font-bold text-9xl dark:text-gray-400">
        <span class="sr-only">Error</span>404
      </p>
      <p class="text-2xl font-semibold md:text-3xl">
        Lo sentimos, no pudimos encontrar esta página.
      </p>
      <div class="mt-4 mb-8 dark:text-gray-600">
        Pero no te preocupes, puedes encontrar muchas otras cosas en nuestra
        página de inicio.
      </div>
      <a
        rel="noopener noreferrer"
        href="#"
        class="px-8 py-3 font-semibold rounded dark:bg-violet-600 dark:text-gray-50"
        >Regresar a Home</a
      >
    </div>
  </div>
</section>
